import styled from "styled-components";

export const QuickTestContainerStyled = styled.div`
  padding: 20px 18px 104px 18px;
  .breadcrumb_layout {
    margin-bottom: 30px;
  }
  .quick_test_container {
    margin: auto;
    max-width: ${({ theme }) => theme.ETC.ACTIVITY_DETAIL_WIDTH};
    .form_title {
      margin-bottom: 10px;
      color: ${({ theme }) => theme.COLORS.BLACK_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
    }
  }

  @media (max-width: ${({ theme }) => theme.SCREENS.SURFACE_DUO}) {
    padding: 40px 18px 104px 18px;
    .breadcrumb_layout {
      display: none;
    }
  }
`;
